import React, { Component } from 'react';

import Slider from 'react-slick';
// import { withFirebase } from '../../Firebase';
import slide_1 from "../../assets/slide_1.jpg";

const settings = {
  customPaging: function(i) {
    return (
      <span></span>
    );
  },
  dotsClass: 'slick-dots slick-thumb',
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 5000,
  className: 'home-slider',
};

export const SLIDES = [{
  src: slide_1,
  alt: 'Ecole de danse Toulouse'
}];

export default class HomeSlider extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     loading: false,
  //     slides: [],
  //   }
  // }

  // componentDidMount() {
  //   this.setState({ loading: true });
    
  //   this.props.firebase.getSlides().then(snapshot => {
  //     let array = [];
  //     snapshot.forEach((doc) => {
  //       array.push(doc.data());
  //     });
  //     this.setState({ slides: array, loading: false });
  //   }).catch((error) => {
  //     console.log("Error getting documents: ", error);
  //   });
  // }

  render() {
    return (
      <Slider {...settings}>
        {
          SLIDES.map((slide) => {
            return (
                <div>
                  <img src={slide.src} className="img-slider" alt={slide.alt} />
                </div>
            )
          })
        }
      </Slider>
    );
  }
}

// export default withFirebase(HomeSlider);
